import React, { useMemo, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useAITTheme, type AITTheme } from '@this/shared/ui/theme';
import SidebarMenu from '../trip_ai_messages/components/SidebarMenu';
import HistoryListPanel from '../trip_ai_messages/components/HistoryListPanel';
import { createDraftTripWithMessage } from '../trip_ai_messages/api/messages';
import NewChatWelcome from './NewChatWelcome';
import NewChatInput from './NewChatInput';

const TripAiMessagesNewPage = () => {
  const { theme } = useAITTheme();
  const history = useHistory();
  const styles = useMemo(() => getStyles(theme), [theme]);
  const [showHistoryList, setShowHistoryList] = useState(false);

  const handleSend = useCallback(
    async (text: string) => {
      const result = await createDraftTripWithMessage(text, []);
      history.replace({
        pathname: `/trips/${result.tripId}/ai_messages`,
        state: { initialMessage: text }
      });
    },
    [history]
  );

  const handleShowHistoryList = () => {
    setShowHistoryList(true);
  };

  const handleHideHistoryList = () => {
    setShowHistoryList(false);
  };

  return (
    <div style={styles.root}>
      <div style={styles.body}>
        <SidebarMenu currentTripId="new" onShowAllHistory={handleShowHistoryList} />
        {showHistoryList ? (
          <HistoryListPanel onBack={handleHideHistoryList} />
        ) : (
          <main style={styles.mainArea}>
            <NewChatWelcome />
            <NewChatInput onSend={handleSend} />
          </main>
        )}
      </div>
    </div>
  );
};

const getStyles = (theme: AITTheme) => ({
  root: {
    width: '100%',
    height: 'calc(100vh - 80px)',
    display: 'flex' as const,
    flexDirection: 'column' as const,
    minHeight: 0
  },
  body: {
    display: 'flex' as const,
    flex: 1,
    position: 'relative' as const,
    backgroundColor: theme.whiteColor,
    border: `1px solid ${theme.grayBorderColor}`,
    borderRadius: '8px',
    overflow: 'hidden',
    minHeight: 0
  },
  mainArea: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    justifyContent: 'center',
    gap: '32px',
    padding: '24px',
    minHeight: 0
  }
});

export default TripAiMessagesNewPage;
